
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import CountDown from '@/components/vue2-countdown'
import config from '@/config'
import { getUserAccount } from '@/api/user.js'
import { getActivity, getJoin, getPersonTuangou } from '@/api/youzheng.js'
import success from '@/assets/success.png'
import fail from '@/assets/fail.png'
import tabIco1 from '@/assets/ico-all-02.png'
import tabIco2 from '@/assets/ico-all-01.png'
import tabIco3 from '@/assets/ico-my-01.png'
import tabIco4 from '@/assets/ico-my-02.png'
import Scroll from '@/components/scroller'
import { getaddlog } from '@/api/hgfw'
export default {
name: 'bulk',
components: {
Group,
Cell,
CountDown,
Scroll,
Tab,
TabItem
},
data () {
return {
baseUrl: config.baseUrl,
list: [],
page: 1,
rows: 10,
currentTime: '',
success: success,
fail: fail,
notFirstLoad: false,
loadMoreDom: null,
listDom: null,
tablist: [
{
title: '团购活动',
ico1: tabIco1,
ico2: tabIco2
}, {
title: '我的团购',
ico1: tabIco3,
ico2: tabIco4
}
],
select: 0
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120115
}).then(res => {
})
},
onTab (index) {
this.notFirstLoad = false
this.page = 1
this.list = [],
this.select = index
if (index == 0) {
this.getlist()
} else {
this.getPersonlist()
}
},
getlist (type, done) {
getActivity({
page: this.page,
rows: this.rows,
accountid: this.accountid
}).then(res => {
if (res.returnValue.total === 0) {
this.loadMoreDom.innerText = ''
}
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.list = []
this.listDom.scrollTop = 0
}
if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
res.returnValue.rows.forEach((item, index) => {
this.$set(this.list, this.list.length, item)
})
}
if ((res.returnValue.rows.length === 0 || res.returnValue.total < this.rows) && res.returnValue.total > 0) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
this.list.forEach(item => {
item.signstartdate = new Date(item.signstartdate.replace(/-/g, '/')).getTime()
item.signenddate = new Date(item.signenddate.replace(/-/g, '/')).getTime()
})
})
},
getPersonlist (type, done) {
getPersonTuangou({
accountid: this.accountid,
page: this.page,
rows: this.rows
}).then(res => {
if (res.returnValue.total === 0) {
this.loadMoreDom.innerText = ''
}
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.list = []
this.listDom.scrollTop = 0
}
if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
res.returnValue.rows.forEach((item, index) => {
this.$set(this.list, this.list.length, item)
})
}
if ((res.returnValue.rows.length = 0 || res.returnValue.total < this.rows) && res.returnValue.total > 0) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
this.list.forEach((item, i) => {
this.$set(this.list[i], 'isjoin', 1)
})
done && done()
this.list.forEach(item => {
item.signstartdate = new Date(item.signstartdate.replace(/-/g, '/')).getTime()
item.signenddate = new Date(item.signenddate.replace(/-/g, '/')).getTime()
})
})
},
countDownS_cb: function (x) {
},
countDownE_cb: function (x) {
},
goDetail (id) {
this.$router.push({ name: 'tuanGouDetail', params: { id: id } })
},
joinGroup (id) {
getJoin({
groupid: id,
accountid: this.accountid
}).then(res => {
var _this = this
this.$vux.alert.show({
title: '提示',
content: '参团成功',
onShow () {
},
onHide () {

_this.list.forEach((item, i) => {
if (item.id === id) {
_this.getlist('refresh')
}
})
}
})
})
},
NojoinGroup () {
},

refresh (done, index) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
if (this.select === 0) {
this.getlist('refresh', done)
} else {
this.getPersonlist('refresh', done)
}
},

loadMore (done, index) {
this.page++
if (this.select === 0) {
this.getlist('more', done)
} else {
this.getPersonlist('more', done)
}
}
},
created () {
this.getAdd()
this.getlist()
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
var timestamp = (new Date()).getTime()
this.currentTime = timestamp
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
}
}
